// extracted by mini-css-extract-plugin
export default {"container":"aG-z","vocBtn":"bG-z","disabled":"cG-z"};